import { SIGNEDUP_SUCCESS, ON_EMAIL_SUBSCRIPTION, CLICKED_ON_VIEW_GUIDE_PORFILE, CLICKED_ON_REQUEST_PORTER_GUIDE, CLICKED_ON_REQUEST_GUIDE, PORTER_GUIDE_PAYMENT_SUCCESS, GUIDE_PAYMENT_SUCCESS } from './types';
export var onSignupSuccess = function onSignupSuccess(provider) {
  return {
    type: SIGNEDUP_SUCCESS,
    signedUpBy: provider
  };
};
export var onEmailSubscription = function onEmailSubscription() {
  return {
    type: ON_EMAIL_SUBSCRIPTION
  };
};
export var onRequestPorterGuide = function onRequestPorterGuide() {
  return {
    type: CLICKED_ON_REQUEST_PORTER_GUIDE
  };
};
export var onViewGuideProfile = function onViewGuideProfile() {
  return {
    type: CLICKED_ON_VIEW_GUIDE_PORFILE
  };
};
export var onRequestGuide = function onRequestGuide() {
  return {
    type: CLICKED_ON_REQUEST_GUIDE
  };
};
export var porterGuidePaymentSuccess = function porterGuidePaymentSuccess(amount) {
  return {
    type: PORTER_GUIDE_PAYMENT_SUCCESS,
    amount: amount
  };
};
export var guidePaymentSuccess = function guidePaymentSuccess(amount) {
  return {
    type: GUIDE_PAYMENT_SUCCESS,
    amount: amount
  };
};